export default {
  default: {
    adjustFilters: 'Adjust your filters to return more results.',
    paragraph: "To professionally pitch for a seller's business you need to present an informative and comprehensive document outlining your experience, knowledge and suggestions.",
    title: 'No Templates Available',
    subTitle: "Don't just market to your clients, engage with them.",
  },
}
